import type { IconName } from '@customerio/pluma-icons';

export function getFileIcon(mimeType: string): IconName {
  if (mimeType.startsWith('image/')) return 'image' as IconName;
  if (mimeType === 'application/pdf') return 'description' as IconName;
  if (mimeType.startsWith('text/')) return 'description' as IconName;
  return 'attach-file' as IconName;
}
